var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 2.66667V13.3333C26 14.0406 25.7261 14.7189 25.2385 15.219C24.7509 15.719 24.0896 16 23.4 16H2.6C1.91107 15.9979 1.25094 15.7163 0.763795 15.2166C0.276646 14.717 0.00205754 14.0399 0 13.3333V2.66667C0.00205754 1.96007 0.276646 1.28302 0.763795 0.78338C1.25094 0.28374 1.91107 0.0021103 2.6 0H23.4C24.0889 0.0021103 24.7491 0.28374 25.2362 0.78338C25.7234 1.28302 25.9979 1.96007 26 2.66667ZM15.5051 9.38933L18.525 6.74133L14.5483 6.4L13 2.66667L11.4517 6.4L7.475 6.74133L10.4949 9.38933L9.5849 13.3333L13 11.2373L16.4151 13.3333L15.5051 9.38933Z",
    fill: "#815AD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.6780e7e9c6eb059e45de548075db785c.svg";
export { ForwardRef as ReactComponent };